import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'soft-field-ok-ekorg-list-view',
  imports: [],
  templateUrl: './ekorg.list-view.html',
  styleUrls: ['./ekorg.list-view.css'],
})
export class ekorgListView implements FieldOkItemComponent<any> {
  readonly item = input<any>();
}
